import React from "react";

import { AaaIntroStudioDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyAaaStudioProps = {
  dataInForm: AaaIntroStudioDataType;
};

const StudioConfig: Map<string, ReadOnlyFormItem> = new Map([
  ["studioName", {}],
  ["businessName", { title: "legallyRegisteredBusinessName" }],
  ["studioWebsite", {}],
]);

export const ReadOnlyAaaStudio = ({ dataInForm }: ReadOnlyAaaStudioProps) => (
  <ReadOnlyForm formConfig={StudioConfig} formData={dataInForm} />
);
